// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"WV-z","inlineTitle":"XV-z","sponsoredAdsWrapper":"YV-z","marketplaceRecosWrapper":"ZV-z"};